interface EmptyStateProps {
  icon: string;
  title: string;
  description: string;
}

export default function EmptyState({ icon, title, description }: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center px-6 py-16 text-center">
      <span className="flex h-14 w-14 items-center justify-center rounded-full bg-background-100">
        <i className={`${icon} text-2xl text-foreground-400`}></i>
      </span>
      <p className="mt-4 text-sm font-semibold text-foreground-900">{title}</p>
      <p className="mt-1 max-w-xs text-sm text-foreground-500">{description}</p>
    </div>
  );
}